module.exports = __webpack_public_path__ + "static/media/cred-3.ac580d04.gif";